import { RootState } from '../store';

export const selectUserRank = (state: RootState) => state.leaderboard.user_rank;
export const selectLeaderboardData = (state: RootState) => state.leaderboard.leaderboard;
export const selectLeaderboardCount = (state: RootState) => state.leaderboard.count;
export const selectLeaderboardLoading = (state: RootState) => state.leaderboard.loading;
export const selectLeaderboardError = (state: RootState) => state.leaderboard.error;
